export const PROVIDER_META = {
  anthropic: {
    name: "Claude",
    vendor: "Anthropic",
    placeholder: "sk-ant-…",
    getKeyUrl: "https://console.anthropic.com/settings/keys",
    blurb: "Best for synthesising research into clean, well-written entity descriptions.",
  },
  perplexity: {
    name: "Perplexity",
    vendor: "Perplexity",
    placeholder: "pplx-…",
    getKeyUrl: "https://www.perplexity.ai/settings/api",
    blurb: "Best for research — it searches the live web and returns real citations.",
  },
  openai: {
    name: "ChatGPT",
    vendor: "OpenAI",
    placeholder: "sk-…",
    getKeyUrl: "https://platform.openai.com/api-keys",
    blurb: "A strong all-round alternative for drafting and reasoning.",
  },
};

export const PROVIDER_ORDER = ["perplexity", "anthropic", "openai"];
